import React, { Component } from 'react';
import Error from '../components/Error404';
import withAppLayout from '../components/appLayout';

class Error404 extends Component {
  public render() {
    return <Error />;
  }
}

export default withAppLayout({ title: 'CleartaxInvest' }, Error404);



// WEBPACK FOOTER //
// ./pages/redirect.tsx